routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.tunnel', {
      url: "/tunnel",
      template: `<tunnel sh-ctrl="shCtrl"></tunnel>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/tunnel/tunnel.config.js
 **/